<template>
  <p> Leave </p>
</template>

<script>
  export default {
    name: 'LeaveView',
    
    data: () => ({
 
    }),
  }
</script>